export class PlanOrderDetailModel{
    type: string;    
    weeks: number;
    mealPerDay: number;
    dayPerWeek: number;
    allergies: any[];
    categories: any[];
    goal: number;
    
    constructor(){
        this.type = '';
        this.weeks = 0;
        this.mealPerDay = 0;
        this.dayPerWeek = 0;
        this.allergies = [];
        this.categories = [];
        this.goal = 0;
    }
}